<template>
  <div>
    <b-modal
      id="createTestDataModal"
      title="Búa til prufuumsóknir"
      size="md"
      lazy
      :no-close-on-backdrop="true"
      ok-title="Búa til"
      cancel-title="Hætta við"
      @ok.prevent="validateBeforeSubmit"
      :ok-disabled="loading || count < 1"
      ref="createModal"
    >
      <div>
        <p>
          Býr til gervigögn (umsóknir með tilbúinni kennitölu og bankareikningi) framhjá Þjóðskrá og banka. Aðeins í boði fyrir ofurnotendur
          í prófunarumhverfi.
        </p>
        <b-form-group label="Fjöldi umsókna" label-for="testDataCount">
          <b-form-input id="testDataCount" name="testDataCount" type="number" min="1" v-model.number="count" :disabled="loading" />
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import appl from '@/api/application';

export default {
  name: 'create-test-data-modal',
  data() {
    return {
      loading: false,
      count: 1,
    };
  },
  methods: {
    async validateBeforeSubmit() {
      const count = Number.parseInt(this.count, 10);
      if (!count || count < 1) {
        this.displayError('Fjöldi verður að vera að minnsta kosti 1.');
        return;
      }

      this.loading = true;
      try {
        const response = await appl.applicationCreateTestData(count);
        const created = (response.data && response.data.created) || [];
        this.displaySuccess(`${created.length} prufuumsókn(ir) búnar til.`);
        this.$emit('successful', {});
        this.$refs.createModal.hide();
      } catch (e) {
        this.$log.debug(e);
        const status = e.response ? e.response.status : -1;
        if (status === 403) {
          this.displayError('Prufugagnasmíð er óvirk eða þú hefur ekki réttindi.');
        } else {
          this.displayError(`Óvænt villa (${status}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      } finally {
        this.loading = false;
      }
    },
    show() {
      this.count = 1;
      this.$refs.createModal.show();
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>
